import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
// import { ReactComponent as SeparatorIcon } from '../separatorIcon.svg';
import { SortableContainer, SortableElement } from '../../../_common/SortableHOC'
// import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    // color: theme.palette.primary.main,
    color: "#2a2d64",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    // backgroundColor: theme.palette.primary.main,
    backgroundColor: "#2a2d64",
    fontWeight: 600,
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: '5px 15px',
  },
}));

const SortableHead = SortableContainer(({ children, containerRef }) => {
  return (
    <TableHead ref={containerRef}>
      <TableRow>{children}</TableRow>
    </TableHead>
  );
});

const SortableCell = SortableElement(({ value, domRef }) => {
  return React.cloneElement(value, { ref: domRef });
});

const EnhancedTableHead = (props) => {
  const {
    order, screenerTableCols, orderBy, onRequestSort, wrapperClass, handleSortedCells, onReorderEnd,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
    handleSortedCells(event, property);
  };

  return (
    <SortableHead axis="x" onSortEnd={onReorderEnd} distance={5}>
      <TableCell padding="checkbox" sx={{ background: '#fff' }} />
      {screenerTableCols?.map((headCell, i) => {
        const classField = headCell?.field ? headCell?.field?.replace(/[^\w\s]/gi, '') : '';
        return (
          <SortableCell
            index={i}
            disabled={headCell?.name === 'Ticker' || headCell?.name === 'Name' ? true : false}
            key={`head-${headCell?.field || i}`}
            value={
              <LightTooltip describeChild key={`tooltip-${headCell?.field || i}`} title={headCell?.tooltip} arrow placement="top-start" disableInteractive>
                <TableCell
                  className={`${wrapperClass || ''} ${orderBy === headCell?.field ? `${order}-table-cell` : ''} ${classField}-th th`}
                  align="left"
                  sortDirection={orderBy === headCell?.field ? order : false}
                  sx={{
                    background: '#fff',
                    whiteSpace: 'nowrap',
                    padding: '6px 12px !important',
                    fontWeight: '700 !important',
                    fontSize: '0.72rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    color: '#5a5e73',
                    '& .MuiSvgIcon-root.drag-drop': { marginLeft: '-6px' },
                  }}
                >
                  <DragIndicatorRoundedIcon
                    className="drag-drop"
                    sx={{
                      verticalAlign: 'middle',
                      opacity: (headCell?.field === 'ticker' || headCell?.field === 'tickername') ? 0 : .35,
                      display: (headCell?.field === 'ticker' || headCell?.field === 'tickername') ? 'none' : 'inline',
                      fontSize: '1rem', cursor: 'grab',
                    }}
                  />
                  <TableSortLabel
                    active={orderBy === headCell?.field}
                    direction={orderBy === headCell?.field ? order : 'asc'}
                    onClick={createSortHandler(headCell?.field)}
                  >
                    <span className="mr-1">
                      {headCell?.name}
                    </span>
                    {orderBy === headCell?.field ? (
                      <span style={{ border: 0, clip: 'rect(0 0 0 0)', height: '1px', margin: '-1px', overflow: 'hidden', padding: 0, position: 'absolute', top: '20px', width: '1px' }}>
                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </span>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              </LightTooltip>
            }
          />)
      })}
    </SortableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default EnhancedTableHead;
